import { render, staticRenderFns } from "./vitel.vue?vue&type=template&id=f613cd98&scoped=true"
import script from "./vitel.vue?vue&type=script&lang=js"
export * from "./vitel.vue?vue&type=script&lang=js"
import style0 from "./vitel.vue?vue&type=style&index=0&id=f613cd98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f613cd98",
  null
  
)

export default component.exports